// Общие утилиты таблицы сравнения фич — используются обоими движками
// (Features/index.tsx + OneFeaturesGroup.tsx для public, FeaturesFull.tsx + useFeaturesFull.ts для v424).
// Раньше дублировались: normalizeTeams ×3, компаратор сортировки групп ×2.
// FEATURE_GROUP_ORDER НЕ выносим — он намеренно различается между поверхностями (состав/порядок групп).

// Нормализует поле teams: "a,b" в единственном элементе массива → ["a","b"]; иначе возвращает как есть.
export const normalizeTeams = (teams?: string[] | string | null) => {
  if (!teams) {
    return null
  }

  if (Array.isArray(teams) && teams.length === 1 && typeof teams[0] === "string" && teams[0].includes(",")) {
    return teams[0].split(",").map((team) => team.trim())
  }

  return teams
}

// Порядок колонок в options[] фич (как в locales/ru.json → featuresList).
export const FEATURE_COLUMN_INDEX: Record<string, number> = {
  marketing: 0,
  marketingExpert: 1,
  enterpriseMarketing: 2,
  core: 3,
  support: 4,
  supportEnterprise: 5,
}

// Колонки для публичной /price/ по выбранной команде (3 колонки).
export const TEAM_FEATURE_INDICES: Record<string, number[]> = {
  marketing: [0, 1, 2],
  support: [3, 4, 5],
}

// Сортирует группы по заданному порядку имён. Группы вне порядка уходят в конец (стабильно).
export const sortGroupsByOrder = <T extends { groupName: string }>(groups: T[], order: string[]): T[] => {
  return groups.slice().sort((firstGroup, secondGroup) => {
    const firstIndex = order.indexOf(firstGroup.groupName)
    const secondIndex = order.indexOf(secondGroup.groupName)

    if (firstIndex === -1 && secondIndex === -1) {
      return 0
    }

    if (firstIndex === -1) {
      return 1
    }

    if (secondIndex === -1) {
      return -1
    }

    return firstIndex - secondIndex
  })
}
